export default {
    state: {
        appData: null,
        snackMsg: {show: false, text: '', msgBar: true},
        loading: false,
        linearLoading: false,

        announcementDismissed: false,

        homeData: {
            featured_courses: null,
            latest_courses: null,
            packages: null,
        },
        welcomeData: {
            featured_courses: null,
        },
    },
    mutations: {
        SET_APP_DATA(state, payload){
            state.appData = payload.data;
        },
        SET_HOME_DATA(state, payload){
            state.homeData = payload.data;
        },
        SET_WELCOME_DATA(state, payload){
            state.welcomeData = payload.data;
        },
        SET_SNACK_MSG(state, msg){
            state.snackMsg = msg;
        },
        SET_LOADING(state, loading){
            state.loading = loading;
        },
        SET_LINEAR_LOADING(state, loading){
            state.linearLoading = loading;
        },
        SET_ANNOUNCEMENT_DISMISSED(state, dismissed){
            state.announcementDismissed = dismissed;
        },

    },
    actions: {
        loadAppData({commit}){
            let url = '/app';
            return window.axios.get(url).then(response=>{
                commit('SET_APP_DATA', {data: response.data});
            });
        },
        loadHomeData({commit}){
            let url = '/home';
            return window.axios.get(url).then(response=>{
                commit('SET_HOME_DATA', {data: response.data});
            });
        },
        loadWelcomeData({commit}){
            let url = '/welcome';
            return window.axios.get(url).then(response=>{
                commit('SET_WELCOME_DATA', {data: response.data});
            });
        },
        setLoading({commit}, payload){
            commit('SET_LOADING', payload.loading);
        },
        addSnackMsg({commit}, msg){
            commit('SET_SNACK_MSG', msg);
        },
    }
}